import React, { useState, useRef } from 'react';
import { View, StyleSheet, Animated } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import { scale, fullWidth, width } from '@components/frame';
import { isWeb, isPhone, dateToSeconds } from '@helpers';
import Button from '@styles/buttons';
import WheelTimePicker from '@components/common/WheelTimePicker';
import EditableLine from '@components/common/editableLine';

import { addProductionInformation } from '@reducers/manufacture';
import { EditTimeProps } from '@v2/pages/machines/common/types/event';

const fields = [
  {
    name: 'Runtime per piece',
    Component: WheelTimePicker,
    noArrow: true,
    key: 'runtimePerPiece',
    isTime: true,
    small: false,
  },
  {
    name: 'Change time per piece',
    Component: WheelTimePicker,
    noArrow: true,
    key: 'changeTimePerPiece',
    isTime: true,
    small: false,
  },
  {
    name: 'Setup time',
    Component: WheelTimePicker,
    noArrow: true,
    key: 'setupTime',
    isTime: true,
    small: false,
  },
];

const EditTime = ({ C, setShowEditTime, runtimePerPiece, changeTimePerPiece, setupTime, addProductionInformation, eventInfo }: EditTimeProps) => {
  const date = { h: '0', m: '0', s: '0' };

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({
    runtimePerPiece: runtimePerPiece || date,
    changeTimePerPiece: changeTimePerPiece || date,
    setupTime: setupTime || date,
  });
  const [pressStyle, setPressStyle] = useState({
    runtimePerPiece: true,
    changeTimePerPiece: true,
    setupTime: true,
  });
  const updateData = (key, value) => {
    const newData = Object.assign({}, data);
    newData[key] = value;
    setData(newData);
  };

  const baseHeight = 0;
  const animation = {
    runtimePerPiece: useRef(new Animated.Value(baseHeight)).current,
    changeTimePerPiece: useRef(new Animated.Value(baseHeight)).current,
    setupTime: useRef(new Animated.Value(baseHeight)).current,
  };

  const openKey = (key) => {
    if (isWeb) {
      return;
    }

    Object.keys(animation).map((k) => {
      if (k !== key) {
        Animated.timing(animation[k], {
          toValue: baseHeight,
          duration: 500,
          useNativeDriver: false,
        }).start();
      }
    });
    const big = scale(200);

    const pressStyle = Object.assign({}, data);
    if (animation[key] && animation[key]._value == big) {
      Animated.timing(animation[key], {
        toValue: baseHeight,
        duration: 500,
        useNativeDriver: false,
      }).start();
      pressStyle[key] = true;
    } else {
      if (animation[key]) {
        Animated.timing(animation[key], {
          toValue: big,
          duration: 500,
          useNativeDriver: false,
        }).start();
        pressStyle[key] = false;
      }
    }
    setPressStyle(pressStyle);
  };

  const submit = async () => {
    setLoading(true);
    const playload = {
      clampingDetails: {
        runTimePerPcsSecond: dateToSeconds(data.runtimePerPiece),
        changeTimePerPcsSecond: dateToSeconds(data.changeTimePerPiece),
        setupTimeSecond: dateToSeconds(data.setupTime),
        machineId: eventInfo.machineId,
        ncFile: eventInfo?.ncFileMain,
        // ncFileId: selectedItem.machineStatus.ncFileId,
        // ncFileHash: selectedItem.machineStatus.ncFileContentHash,
        // memo: data.clampingMemo,
        // setupSheet: 'string', ???
      },
      part: {
        // partName: data.part,
        // description: data.description,
        // drawing: data.drawing,
        // revision: data.revision,
        // position: data.pos,
      },
    };

    await addProductionInformation(playload);
    setLoading(false);
    setShowEditTime(false);
  };

  return (
    <View
      style={{
        width: isWeb ? fullWidth : '100%',
        marginLeft: isWeb ? -(fullWidth - width) / 2 : 0,
        left: 0,
        top: 0,
        flex: 1,
        height: '100%',
        paddingBottom: isWeb ? scale(300) : 0,
        backgroundColor: C('Overlay/Light/Picture dark'),
        position: 'absolute',
        zIndex: 100000,
        paddingHorizontal: scale(9),
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
      }}
    >
      <View style={{ width: isPhone ? '100%' : scale(400), backgroundColor: C('Background/Light/Field'), borderRadius: scale(10) }}>
        <View
          style={{
            width: '100%',
            height: scale(52),
            borderBottomColor: C('Hairline/Light/No trans'),
            borderBottomWidth: StyleSheet.hairlineWidth,
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Button {...{ variant: 'L', type: 'Only Text Link', onPress: () => setShowEditTime(false), borderRadius: scale(10) }}>
            {i18n.t('Cancel')}
          </Button>
          <Button {...{ variant: 'L', type: 'Only Text Link', onPress: () => submit(), borderRadius: scale(10), loading }}>{i18n.t('Done')}</Button>
        </View>
        <View>
          {fields.map((item, index) => (
            <EditableLine
              {...{
                item: {
                  value: data[item.key],
                  onChange: (v) => updateData(item.key, v),
                  onClick: () => openKey(item.key),
                  animatedHeight: animation[item.key],
                  justifyContent: 'flex-end',
                  paddingRight: scale(20),
                  isOffset: false,
                  ...item,
                },
                pressStyle: pressStyle[item.key],
                index,
                array: fields,
                C,
                bottomBorderBox: false,
                topBorder: index !== 0,
                roundTop: false,
                roundBottom: index === fields.length - 1,
              }}
              key={item.key}
            />
          ))}
        </View>
      </View>
    </View>
  );
};

export default connect(null, { addProductionInformation })(EditTime);
